import React from 'react';
import { locales } from '../../../translations/locales';
import { FaChevronRight } from 'react-icons/fa6';
import moment from 'moment';
import IconsCategories from './IconsCategories';

const Alert = (props) => {
    const { alert, locale, setNewAlert } = props;

    return (
        <div
            className={`col-12 btn btn-${alert.danger === 1 ? 'danger' :
                alert.danger === 2 ? 'warning' :
                    alert.danger === 3 ? 'light' :
                        'secondary'}
            text-left m-2`}
            onClick={() => setNewAlert(alert)}
        >
            <div className='row'>
                <div className='col-2'>
                    <div>
                        {moment(alert.timestamp).format('DD/MM/YYYY HH:mm')}
                    </div>
                    <div>
                        N-{alert.number}
                    </div>
                </div>
                <div className='col-2'>
                    <IconsCategories locale={locale} icon={alert.qualification.category} style={'30px'} noText={true} />
                </div>
                <div className='col-6'>
                    <div>
                        {locales[locale].sga[alert.qualification.category]}
                        <FaChevronRight className='m-1' />
                        {alert.qualification.qualification}
                    </div>
                    <div>
                        {locales[locale].sig[alert.qualification.place.category]}
                        <FaChevronRight className='m-1' />
                        {locales[locale].sig[alert.qualification.place.type]}
                    </div>
                    <div>
                        {alert.location.numero} {alert.location.address} {alert.location.city}
                    </div>
                </div>
                <div className='col-2'>
                    <div className={`badge badge-${alert.vehicles.length > 0 ? 'success' : 'warning'} p-2 m-1`}>
                        {alert.vehicles.length} {locales[locale].sgo.vehicles}
                    </div>
                    <div className={`badge badge-${alert.notifications.length > 0 ? 'danger' : 'secondary'} p-2 m-1`}>
                        {alert.notifications.length} {locales[locale].sgo.notifications}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Alert;
